<ideal-image image *renderInProductResult="LayoutTargets.Images" [src]="thumbnailUrl()" [attr.layout]="layout()"></ideal-image>

<ideal-product-id-label product-id [productId]="id()" *renderInProductResult="LayoutTargets.Title"></ideal-product-id-label>
<ideal-product-short-description
  description
  [productId]="id()"
  [maxLines]="layout() === 'row' ? 3 : 2"
  [attr.line]="layout() === 'row'"
  *renderInProductResult="LayoutTargets.Title"
></ideal-product-short-description>

<ideal-product-is-canadian
  canadian
  [productId]="id()"
  *renderInProductResult="LayoutTargets.ImagesOverlay"
  class="canadian"
></ideal-product-is-canadian>

<ideal-product-not-returnable
  not-returnable
  line
  [productId]="id()"
  *renderInProductResult="LayoutTargets.Stock"
></ideal-product-not-returnable>

<ng-container *renderInProductResult="LayoutTargets.Stock">
  <ideal-item-stock-button [itemId]="id()" />
</ng-container>

<ng-container *renderInProductResult="LayoutTargets.Price">
  <ideal-item-price
    [itemId]="id()"
    sizing="fixed"
    disableCallForPrice="true"
    [usePricePer]="layout() === 'card' ? 'sold-in+container' : 'sold-in'"
    layout="horizontal"
  ></ideal-item-price>
</ng-container>

<!-- <div stock-qty *renderInProductResult="LayoutTargets.Stock">123 in fake stock</div> -->

<!--
<div pricing *renderInProductResult="LayoutTargets.Actions" [attr.layout]="layout()">
  @if (layout() === "card") {
    <ideal-item-stock-button [itemId]="id()" />
  } @else {
    <div></div>
  }
</div>
@if (layout() === "row") {

} -->
